import { PROTOCOLS, PROTOCOL_MAX, protocolById } from '../data/protocols';
import { recalcStats, registerModSource } from './stats';
import { metProtocol } from './metrics';
/* ============================================================
   破格協定的持有狀態（傳說級選項）
   ============================================================

   資料與三條設計約束在 `data/protocols.ts`。這裡只管：
   拿了哪些、還能不能再拿、以及把修正丟進 `sim/stats.ts`。

   形狀刻意跟 `sim/mech-upgrades.ts` 一模一樣（不佔槽、獨立上限、
   自己註冊 modSource、重置責任併進 `resetLoadout()`）。照抄既有 pattern
   而不是自創第三種寫法 —— 這個專案記過一次「新欄位忘了在 startRun 歸零」。

   **只有一級**：協定是方向宣告不是連續加成（見資料檔的「為什麼不做成被動的
   第 6 級」）。所以這裡存的是持有清單而不是等級表。 */

/** 這一場拿到的協定 id。**用陣列不用物件** —— 走訪順序必須是決定性的
    （`sim/loadout.ts` 檔頭記過同一件事）。 */
var taken: string[] = [];

export function resetProtocols() {
  taken.length = 0;
  recalcStats();
}

export function protocolIds() { return taken.slice(); }
export function hasProtocol(id) { return taken.indexOf(id) >= 0; }
export function protocolCount() { return taken.length; }

/** 還拿得到嗎：沒拿過，而且沒滿 `PROTOCOL_MAX`。 */
export function canTakeProtocol(id) {
  return !!protocolById(id) && !hasProtocol(id) && taken.length < PROTOCOL_MAX;
}

/** 拿一個。回傳 1（成功）或 0 —— 跟 `take()` 的其他分支同一個回傳約定，
    呼叫端才不必為協定寫特例。 */
export function takeProtocol(id) {
  if (!canTakeProtocol(id)) return 0;
  taken.push(id);
  recalcStats();
  /* 埋點接在**唯一的出口**上。上一輪的教訓：`metChest` 定義好卻沒接上，
     第一份報表五顆種子的開箱數全是 0，而那看起來像「機制沒生效」。 */
  metProtocol(id);
  return 1;
}

/** 給快照用。併進 `loadoutDigest()` —— 不併的話「同種子兩場拿到的協定不同」
    對黃金雜湊是隱形的。照 `mechUpDigest()` 的作法：沒拿過就回空字串，
    純表示法的改動不會偽裝成模擬結果變了。 */
export function protocolDigest() {
  var s = '';
  for (var i = 0; i < PROTOCOLS.length; i++) {
    if (hasProtocol(PROTOCOLS[i].id)) s += PROTOCOLS[i].id + ',';
  }
  return s;
}

/* 修正丟進數值層。註冊一次，之後只要 recalcStats。
   走訪 `PROTOCOLS` 而不是 `taken`，順序才與取得順序無關
   —— `sim/stats.ts` 檔頭的第 2 點（同樣的 build 不該因抽選順序而強度不同）。 */
registerModSource(function () {
  var out: any[] = [];
  for (var i = 0; i < PROTOCOLS.length; i++) {
    if (hasProtocol(PROTOCOLS[i].id)) out.push(PROTOCOLS[i].mods(1));
  }
  return out;
});
